




// import React, { useState, useEffect } from "react";
// import { FaPlus, FaEdit, FaTrash } from "react-icons/fa";
// import Modal from "react-modal";

// Modal.setAppElement("#root");

// export default function FoodMenu() {
//   const [packagesData, setPackagesData] = useState({ birthday: [] });
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [editingPackage, setEditingPackage] = useState(null);

//   const [formData, setFormData] = useState({
//     name: "",
//     type: "veg",
//     items: [{ name: "", price: "" }],
//     image: "",
//   });

//   // ---- LOCAL STORAGE LOAD ----
//   useEffect(() => {
//     const saved = localStorage.getItem("packagesData");
//     if (saved) setPackagesData(JSON.parse(saved));
//   }, []);

//   // ---- LOCAL STORAGE SAVE ----
//   useEffect(() => {
//     localStorage.setItem("packagesData", JSON.stringify(packagesData));
//   }, [packagesData]);

//   // ---- MODAL HANDLERS ----
//   const openModal = (pkg = null) => {
//     if (pkg) {
//       setEditingPackage(pkg);
//       setFormData({
//         name: pkg.name,
//         type: pkg.type,
//         items: pkg.items.map((i) => ({ name: i.name, price: i.price })),
//         image: pkg.image || "",
//       });
//     } else {
//       setEditingPackage(null);
//       setFormData({ name: "", type: "veg", items: [{ name: "", price: "" }], image: "" });
//     }
//     setIsModalOpen(true);
//   };

//   const closeModal = () => setIsModalOpen(false);

//   // ---- FORM HANDLERS ----
//   const handleAddItem = () =>
//     setFormData({ ...formData, items: [...formData.items, { name: "", price: "" }] });

//   const handleItemChange = (i, field, value) => {
//     const updated = [...formData.items];
//     updated[i][field] = value;
//     setFormData({ ...formData, items: updated });
//   };

//   const handleRemoveItem = (i) => {
//     setFormData({ ...formData, items: formData.items.filter((_, idx) => idx !== i) });
//   };

//   const handleImageUpload = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       const reader = new FileReader();
//       reader.onloadend = () => setFormData({ ...formData, image: reader.result });
//       reader.readAsDataURL(file);
//     }
//   };

//   // ---- ADD/UPDATE PACKAGE ----
//   const handleSavePackage = () => {
//     const formattedItems = formData.items.map((item, i) => ({
//       id: i + 1,
//       name: item.name,
//       price: Number(item.price),
//       type: formData.type,
//     }));

//     if (editingPackage) {
//       setPackagesData((prev) => ({
//         ...prev,
//         birthday: prev.birthday.map((p) =>
//           p.id === editingPackage.id
//             ? { ...p, name: formData.name, type: formData.type, items: formattedItems, image: formData.image }
//             : p
//         ),
//       }));
//     } else {
//       const newPkg = {
//         id: Date.now(),
//         name: formData.name,
//         type: formData.type,
//         image: formData.image,
//         items: formattedItems,
//       };
//       setPackagesData((prev) => ({
//         ...prev,
//         birthday: [...prev.birthday, newPkg],
//       }));
//     }

//     closeModal();
//   };

//   // ---- DELETE PACKAGE ----
//   const handleDeletePackage = (id) => {
//     setPackagesData((prev) => ({
//       ...prev,
//       birthday: prev.birthday.filter((p) => p.id !== id),
//     }));
//   };

//   return (
//     <div style={{ padding: "20px" }}>
//       {/* Add Package Button */}
//       <div style={{ textAlign: "left", marginBottom: "20px" }}>
//         <button
//           onClick={() => openModal()}
//           style={{
//             padding: "10px 15px",
//             backgroundColor: "#28a745",
//             color: "white",
//             border: "none",
//             borderRadius: "5px",
//             cursor: "pointer",
//             display: "flex",
//             alignItems: "center",
//             gap: "6px",
//           }}
//         >
//           <FaPlus /> Add New Package
//         </button>
//       </div>

//       {/* Display Packages */}
//       <div
//         style={{
//           display: "grid",
//           gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
//           gap: "20px",
//         }}
//       >
//         {packagesData.birthday.map((pkg) => (
//           <div
//             key={pkg.id}
//             style={{
//               border: "1px solid #ddd",
//               borderRadius: "10px",
//               overflow: "hidden",
//               background: "#fff",
//               boxShadow: "0px 2px 6px rgba(0,0,0,0.1)",
//               display: "flex",
//               flexDirection: "column",
//             //   width:"280px",
//             //   gap:"20px",
//               position: "relative",
//             }}
//           >
//             {/* Image */}
//             <div style={{ position: "relative" }}>
//               {pkg.image ? (
//                 <img
//                   src={pkg.image}
//                   alt={pkg.name}
//                   style={{ width: "100%", height: "160px", objectFit: "cover" }}
//                 />
//               ) : (
//                 <div
//                   style={{
//                     width: "100%",
//                     height: "160px",
//                     background: "#eee",
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "center",
//                     color: "#666",
//                   }}
//                 >
//                   No Image
//                 </div>
//               )}
//               {/* Delete button top-right */}
//               <button
//                 onClick={() => handleDeletePackage(pkg.id)}
//                 style={{
//                   position: "absolute",
//                   top: "10px",
//                   right: "10px",
//                   background: "#dc3545",
//                   border: "none",
//                   borderRadius: "50%",
//                   padding: "6px",
//                   cursor: "pointer",
//                 }}
//               >
//                 <FaTrash color="white" />
//               </button>
//             </div>

//             {/* Content */}
//             <div style={{ padding: "15px", flex: "1" }}>
//               <h3 style={{ margin: "0 0 10px" }}>{pkg.name} Package</h3>
//               <p
//                 style={{
//                   background: pkg.type === "veg" ? "green" : "red",
//                   color: "white",
//                   display: "inline-block",
//                   padding: "2px 10px",
//                   borderRadius: "5px",
//                   fontSize: "12px",
//                 }}
//               >
//                 {pkg.type.toUpperCase()}
//               </p>
//               <ul style={{ marginTop: "10px", paddingLeft: "18px" }}>
//                 {pkg.items.map((item) => (
//                   <li key={item.id}>
//                     {item.name} - ₹{item.price}
//                   </li>
//                 ))}
//               </ul>
//             </div>

//             {/* Footer fixed */}
//             <div
//               style={{
//                 padding: "10px 15px",
//                 borderTop: "1px solid #ddd",
//                 display: "flex",
//                 justifyContent: "space-between",
//                 alignItems: "center",
//                 background: "#f9f9f9",
//               }}
//             >
//               <p style={{ margin: 0, fontWeight: "bold" }}>
//                 Total: ₹{pkg.items.reduce((sum, i) => sum + i.price, 0)}
//               </p>
//               <button
//                 onClick={() => openModal(pkg)}
//                 style={{
//                   background: "#ffc107",
//                   border: "none",
//                   padding: "6px 10px",
//                   borderRadius: "5px",
//                   cursor: "pointer",
//                 }}
//               >
//                 <FaEdit color="white" />
//               </button>
//             </div>
//           </div>
//         ))}
//       </div>

//       {/* Modal */}
//       <Modal
//         isOpen={isModalOpen}
//         onRequestClose={closeModal}
//         contentLabel="Add/Edit Package"
//         style={{
//         //   overlay: { backgroundColor: "rgba(0,0,0,0.5)" },
//           content: {
//             top: "50%",
//             left: "50%",
//             transform: "translate(-50%, -50%)",
//             maxWidth: "420px",
//             width: "90%",
//             borderRadius: "10px",
//             padding: "20px",
//             maxHeight: "90vh",
//             overflowY: "auto",
//           },
//         }}
//       >
//         <h2>{editingPackage ? "Edit Package" : "Add New Package"}</h2>

//         <label>Package Name:</label>
//         <input
//           type="text"
//           value={formData.name}
//           onChange={(e) => setFormData({ ...formData, name: e.target.value })}
//           style={{ width: "100%", padding: "8px", marginBottom: "12px" }}
//         />

//         <label>Package Type:</label>
//         <select
//           value={formData.type}
//           onChange={(e) => setFormData({ ...formData, type: e.target.value })}
//           style={{ width: "100%", padding: "8px", marginBottom: "12px" }}
//         >
//           <option value="veg">Vegetarian</option>
//           <option value="nonveg">Non-Vegetarian</option>
//           <option value="drinks">Drinks</option>
//         </select>

//         <label>Upload Image:</label>
//         <input type="file" accept="image/*" onChange={handleImageUpload} style={{ marginBottom: "12px" }} />

//         <label>Items:</label>
//         {formData.items.map((item, i) => (
//           <div key={i} style={{ display: "flex", marginBottom: "8px", gap: "5px" }}>
//             <input
//               type="text"
//               placeholder="Item name"
//               value={item.name}
//               onChange={(e) => handleItemChange(i, "name", e.target.value)}
//               style={{ flex: 2, padding: "6px" }}
//             />
//             <input
//               type="number"
//               placeholder="Price"
//               value={item.price}
//               onChange={(e) => handleItemChange(i, "price", e.target.value)}
//               style={{ flex: 1, padding: "6px" }}
//             />
//             <button
//               onClick={() => handleRemoveItem(i)}
//               style={{
//                 background: "#dc3545",
//                 border: "none",
//                 color: "white",
//                 padding: "5px 8px",
//                 borderRadius: "3px",
//               }}
//             >
//               ✕
//             </button>
//           </div>
//         ))}

//         <button
//           onClick={handleAddItem}
//           style={{
//             background: "#17a2b8",
//             color: "white",
//             border: "none",
//             borderRadius: "3px",
//             padding: "6px 12px",
//             marginBottom: "15px",
//           }}
//         >
//           + Add Item
//         </button>

//         <p style={{ fontWeight: "bold" }}>
//           Total Price: ₹{formData.items.reduce((sum, i) => sum + (Number(i.price) || 0), 0)}
//         </p>

//         <div style={{ display: "flex", justifyContent: "space-between", marginTop: "15px" }}>
//           <button
//             onClick={closeModal}
//             style={{
//               background: "#6c757d",
//               color: "white",
//               border: "none",
//               borderRadius: "5px",
//               padding: "8px 15px",
//             }}
//           >
//             Cancel
//           </button>
//           <button
//             onClick={handleSavePackage}
//             style={{
//               background: "#28a745",
//               color: "white",
//               border: "none",
//               borderRadius: "5px",
//               padding: "8px 15px",
//             }}
//           >
//             {editingPackage ? "Update" : "Add"}
//           </button>
//         </div>
//       </Modal>
//     </div>
//   );
// }




import React, { useState, useEffect } from "react";
import { FaPlus, FaEdit, FaTrash } from "react-icons/fa";
import Modal from "react-modal";
import DEFAULT_IMAGE from "../Catreingfolder/food.jpg";

Modal.setAppElement("#root");

export default function FoodMenu() {
  // ---- DEFAULT DATA ----
  const defaultPackages = {
    birthday: [
      {
        id: 1,
        name: "Starter Delight",
        type: "veg",
        image: "",
        items: [
          { id: 1, name: "Paneer Tikka", price: 120 },
          { id: 2, name: "Spring Roll", price: 80 },
          { id: 3, name: "Veg Momos", price: 100 },
          { id: 4, name: "Cheese Balls", price: 90 },
          { id: 5, name: "Aloo Tikki", price: 70 },
          { id: 6, name: "Mini Samosa", price: 60 },
          // { id: 7, name: "Corn Chaat", price: 85 },
          // { id: 8, name: "Hara Bhara Kebab", price: 110 },
          // { id: 9, name: "Crispy Mushroom", price: 95 },
          // { id: 10, name: "Fruit Punch", price: 50 },
        ],
      },
      {
        id: 2,
        name: "Non-Veg Fiesta",
        type: "nonveg",
        image: "",
        items: [
          { id: 1, name: "Chicken Tikka", price: 180 },
          { id: 2, name: "Chicken Momos", price: 120 },
          { id: 3, name: "Mutton Seekh", price: 220 },
          { id: 4, name: "Fish Fry", price: 200 },
          { id: 5, name: "Chicken Wings", price: 160 },
          { id: 6, name: "Egg Roll", price: 90 },
          // { id: 7, name: "Chicken Popcorn", price: 140 },
          // { id: 8, name: "Kebab Platter", price: 250 },
          // { id: 9, name: "Prawn Fry", price: 300 },
          // { id: 10, name: "Chicken Soup", price: 100 },
        ],
      },
      {
        id: 3,
        name: "Drinks & Beverages",
        type: "drinks",
        image: "",
        items: [
          { id: 1, name: "Cold Drink", price: 40 },
          { id: 2, name: "Lassi", price: 60 },
          { id: 3, name: "Juice", price: 70 },
          { id: 4, name: "Mocktail", price: 120 },
          { id: 5, name: "Cold Coffee", price: 90 },
          { id: 6, name: "Milkshake", price: 110 },
          // { id: 7, name: "Iced Tea", price: 80 },
          // { id: 8, name: "Hot Coffee", price: 50 },
          // { id: 9, name: "Mineral Water", price: 20 },
          // { id: 10, name: "Energy Drink", price: 150 },
        ],
      },
    ],
  };

  const [packagesData, setPackagesData] = useState(defaultPackages);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingPackage, setEditingPackage] = useState(null);

  const [formData, setFormData] = useState({
    name: "",
    type: "veg",
    items: [{ name: "", price: "" }],
    image: "",
  });

  // ---- LOCAL STORAGE LOAD ----
  useEffect(() => {
    const saved = localStorage.getItem("packagesData");
    if (saved) {
      setPackagesData(JSON.parse(saved));
    } else {
      setPackagesData(defaultPackages); // load default if nothing in storage
    }
  }, []);

  // ---- LOCAL STORAGE SAVE ----
  useEffect(() => {
    localStorage.setItem("packagesData", JSON.stringify(packagesData));
  }, [packagesData]);

  // ---- MODAL HANDLERS ----
  const openModal = (pkg = null) => {
    if (pkg) {
      setEditingPackage(pkg);
      setFormData({
        name: pkg.name,
        type: pkg.type,
        items: pkg.items.map((i) => ({ name: i.name, price: i.price })),
        image: pkg.image || "",
      });
    } else {
      setEditingPackage(null);
      setFormData({ name: "", type: "veg", items: [{ name: "", price: "" }], image: "" });
    }
    setIsModalOpen(true);
  };

  const closeModal = () => setIsModalOpen(false);

  // ---- FORM HANDLERS ----
  const handleAddItem = () =>
    setFormData({ ...formData, items: [...formData.items, { name: "", price: "" }] });

  const handleItemChange = (i, field, value) => {
    const updated = [...formData.items];
    updated[i][field] = value;
    setFormData({ ...formData, items: updated });
  };

  const handleRemoveItem = (i) => {
    setFormData({ ...formData, items: formData.items.filter((_, idx) => idx !== i) });
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => setFormData({ ...formData, image: reader.result });
      reader.readAsDataURL(file);
    }
  };

  // ---- ADD/UPDATE PACKAGE ----
  const handleSavePackage = () => {
    const formattedItems = formData.items.map((item, i) => ({
      id: i + 1,
      name: item.name,
      price: Number(item.price),
      type: formData.type,
    }));

    if (editingPackage) {
      setPackagesData((prev) => ({
        ...prev,
        birthday: prev.birthday.map((p) =>
          p.id === editingPackage.id
            ? { ...p, name: formData.name, type: formData.type, items: formattedItems, image: formData.image }
            : p
        ),
      }));
    } else {
      const newPkg = {
        id: Date.now(),
        name: formData.name,
        type: formData.type,
        image: formData.image,
        items: formattedItems,
      };
      setPackagesData((prev) => ({
        ...prev,
        birthday: [...prev.birthday, newPkg],
      }));
    }

    closeModal();
  };

  // ---- DELETE PACKAGE ----
  const handleDeletePackage = (id) => {
    setPackagesData((prev) => ({
      ...prev,
      birthday: prev.birthday.filter((p) => p.id !== id),
    }));
  };

  return (
    <div style={{ padding: "20px", fontFamily: "Arial, sans-serif", marginTop: "-20px" }}>
      {/* Add Package Button */}
      <div style={{ textAlign: "left", marginBottom: "20px" }}>
        <button
          onClick={() => openModal()}
          style={{
            padding: "8px 12px",
            background: "linear-gradient(45deg, #9850b1ff, #ba66cfff)",
            color: "white",
            border: "none",
            borderRadius: "6px",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            gap: "8px",
            fontWeight: "bold",
            boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
          }}
        >
          <FaPlus /> Add Package
        </button>
      </div>

      {/* Display Packages */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(264px, 1fr))",
          gap: "24px",
        }}
      >
        {packagesData.birthday.map((pkg) => (
          <div
            key={pkg.id}
            style={{
              borderRadius: "12px",
              overflow: "hidden",
              background: "#fff",
              boxShadow: "0px 4px 12px rgba(0,0,0,0.15)",
              transition: "transform 0.2s ease",
            }}
          >
            {/* Image */}
            <div style={{ position: "relative" }}>

              <img
                src={pkg.image || DEFAULT_IMAGE}
                alt={pkg.name}
                style={{ width: "100%", height: "180px", objectFit: "cover" }}
              />

              {/* Delete button top-right */}
              <button
                onClick={() => handleDeletePackage(pkg.id)}
                style={{
                  position: "absolute",
                  top: "10px",
                  right: "10px",
                  background: "#dc3545",
                  border: "none",
                  borderRadius: "50%",
                  padding: "8px",
                  cursor: "pointer",
                  boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                }}
              >
                <FaTrash color="white" />
              </button>
            </div>

            {/* Content */}
            <div style={{ padding: "15px" }}>
              <h3 style={{ margin: "0 0 10px", fontSize: "18px", fontWeight: "bold" }}>
                {pkg.name} Package
              </h3>
              <span
                style={{
                  background:
                    pkg.type === "veg" ? "green" : pkg.type === "nonveg" ? "red" : "#007bff",
                  color: "white",
                  padding: "4px 12px",
                  borderRadius: "20px",
                  fontSize: "12px",
                  fontWeight: "bold",
                }}
              >
                {pkg.type.toUpperCase()}
              </span>
              <ul style={{ marginTop: "12px", paddingLeft: "20px", color: "#444" }}>
                {pkg.items.map((item) => (
                  <li key={item.id} style={{ marginBottom: "4px" }}>
                    {item.name}
                  </li>
                ))}
              </ul>
            </div>

            {/* Footer */}
            <div
              style={{
                padding: "12px 15px",
                borderTop: "1px solid #eee",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                background: "#fafafa",
              }}
            >
              <p style={{ margin: 0, fontWeight: "bold", color: "#333" }}>
                Total: ₹{pkg.items.reduce((sum, i) => sum + i.price, 0)}
              </p>
              <button
                onClick={() => openModal(pkg)}
                style={{
                  background: "#ffc107",
                  border: "none",
                  padding: "6px 12px",
                  borderRadius: "6px",
                  cursor: "pointer",
                  fontWeight: "bold",
                  color: "#fff",
                }}
              >
                <FaEdit />
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* Modal */}
      <Modal
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        contentLabel="Add/Edit Package"
        style={{
          content: {
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            maxWidth: "450px",
            width: "90%",
            borderRadius: "12px",
            padding: "25px",
            maxHeight: "90vh",
            overflowY: "auto",
            boxShadow: "0 6px 20px rgba(0,0,0,0.25)",
          },
        }}
      >
        <h2 style={{ marginBottom: "15px", color: "#333" }}>
          {editingPackage ? "Edit Package" : "Add New Package"}
        </h2>

        <label>Package Name:</label>
        <input
          type="text"
          value={formData.name}
          onChange={(e) => setFormData({ ...formData, name: e.target.value })}
          style={{
            width: "100%",
            padding: "10px",
            marginBottom: "15px",
            borderRadius: "6px",
            border: "1px solid #ccc",
          }}
        />

        <label>Package Type:</label>
        <select
          value={formData.type}
          onChange={(e) => setFormData({ ...formData, type: e.target.value })}
          style={{
            width: "100%",
            padding: "10px",
            marginBottom: "15px",
            borderRadius: "6px",
            border: "1px solid #ccc",
          }}
        >
          <option value="veg">Vegetarian</option>
          <option value="nonveg">Non-Vegetarian</option>
          <option value="drinks">Drinks</option>
        </select>

        <label>Upload Image:</label>
        <input
          type="file"
          accept="image/*"
          onChange={handleImageUpload}
          style={{ marginBottom: "15px" }}
        />

        <label>Items:</label>
        {formData.items.map((item, i) => (
          <div key={i} style={{ display: "flex", marginBottom: "8px", gap: "5px" }}>
            <input
              type="text"
              placeholder="Item name"
              value={item.name}
              onChange={(e) => handleItemChange(i, "name", e.target.value)}
              style={{ flex: 2, padding: "8px", borderRadius: "4px", border: "1px solid #ccc" }}
            />
            <input
              type="number"
              placeholder="Price"
              value={item.price}
              onChange={(e) => handleItemChange(i, "price", e.target.value)}
              style={{ flex: 1, padding: "8px", borderRadius: "4px", border: "1px solid #ccc" }}
            />
            <button
              onClick={() => handleRemoveItem(i)}
              style={{
                background: "#dc3545",
                border: "none",
                color: "white",
                padding: "6px 10px",
                borderRadius: "4px",
                cursor: "pointer",
              }}
            >
              ✕
            </button>
          </div>
        ))}

        <button
          onClick={handleAddItem}
          style={{
            background: "#17a2b8",
            color: "white",
            border: "none",
            borderRadius: "5px",
            padding: "8px 14px",
            marginBottom: "15px",
            cursor: "pointer",
          }}
        >
          + Add Item
        </button>

        <p style={{ fontWeight: "bold", marginBottom: "20px" }}>
          Total Price: ₹{formData.items.reduce((sum, i) => sum + (Number(i.price) || 0), 0)}
        </p>

        <div style={{ display: "flex", justifyContent: "space-between", marginTop: "10px" }}>
          <button
            onClick={closeModal}
            style={{
              background: "#6c757d",
              color: "white",
              border: "none",
              borderRadius: "6px",
              padding: "10px 18px",
              cursor: "pointer",
            }}
          >
            Cancel
          </button>
          <button
            onClick={handleSavePackage}
            style={{
              background: "#28a745",
              color: "white",
              border: "none",
              borderRadius: "6px",
              padding: "10px 18px",
              cursor: "pointer",
              fontWeight: "bold",
            }}
          >
            {editingPackage ? "Update" : "Add"}
          </button>
        </div>
      </Modal>
    </div>
  );
}


